import { takeLatest, call, put, select } from 'redux-saga/effects';
import { push } from 'connected-react-router';

import {
  FETCH_EXPERIENCES_REQUEST,
  FETCH_EXPERIENCES_SUCCESS,
  CLEAR_SEARCH,
  FETCH_EXPERIENCE_REQUEST,
  FETCH_EXPERIENCE_SUCCESS,
  FETCH_EXPERIENCES_ERROR,
} from '../actions/experienceActionTypes';

import Api from '../api/rootApi';

function* fetchExperiences() {
  try {
    const search = yield select((state) => state.experiences.search);

    const { data } = yield call(Api.fetchExperiences, search);
    const experiences = data.data;

    yield put({ type: FETCH_EXPERIENCES_SUCCESS, experiences });
  } catch (error) {
    yield put({ type: FETCH_EXPERIENCES_ERROR, error });
  }
}

function* fetchExperience({ slug }) {
  try {
    const { data } = yield call(Api.fetchExperience, slug);

    yield put({ type: FETCH_EXPERIENCE_SUCCESS, experience: data });
  } catch (error) {
    yield put(push('/'));
  }
}

export const experienceSagas = [
  takeLatest(FETCH_EXPERIENCES_REQUEST, fetchExperiences),
  takeLatest(FETCH_EXPERIENCE_REQUEST, fetchExperience),
  takeLatest(CLEAR_SEARCH, fetchExperiences),
];
